module.exports = __webpack_public_path__ + "static/media/LK_Delete.b09a12fb.svg";